import React from "react";
import { CheckLabel } from "@sscs/ui";
import { CommunityAssessmentStatus } from "Types";
import styles from "./communityVersions.module.scss";

type CommunityDeploymentRiskLabelProps = {
  status: CommunityAssessmentStatus;
};

const CommunityDeploymentRiskLabel = ({
  status,
}: CommunityDeploymentRiskLabelProps): React.JSX.Element => {
  if (status === "pending") {
    return <div className={styles["status-icon"]}>wait</div>;
  }

  const releaseStatus = status === "warning" ? "pass" : status;

  return <CheckLabel status={releaseStatus} />;
};

export default CommunityDeploymentRiskLabel;
